import ExclamationIcon from 'components/Icons/ExclamationIcon'
import { NOTIFIABLE_REOPEN_BLOCKED_MESSAGE } from 'utils/damage'

export interface INotifiableReopenBlockedAlert {
    show: boolean
    message?: string
}

// Exibe aviso de que a notificação não pode ser reaberta
export default function NotifiableReopenBlockedAlert({
    show,
    message = NOTIFIABLE_REOPEN_BLOCKED_MESSAGE
}: INotifiableReopenBlockedAlert) {
    if (!show) {
        return null
    }

    return (
        <div
            data-testid="test-notifiable-reopen-blocked-alert"
            className="mx-8 mt-3 flex items-center gap-2 rounded-lg border border-[#F0B323] bg-[#FFFCF3] px-4 py-2"
        >
            <ExclamationIcon />
            <span className="text-sm text-darkGray">
                {message}
            </span>
        </div>
    )
}
